import React from "react";
import styled from "styled-components";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

import { FormGrid, FormikForm } from "../../../../../forms";
import { ActionButtons } from "../../../../../forms/ActionButtons";
import { inputs } from "../../../../../inputs/inputConfigs";
import { vendorCertificationDataComponentId } from "../VendorCertificationsContainer";

const Wrapper = styled.div``;

const fields = {
  groups: [
    {
      items: [
        {
          input: inputs.name,
          grid: { xs: 12 },
        },
        {
          input: inputs.description,
          grid: { xs: 12 },
        },
      ],
    },
  ],
};

export const CreateVendorCertification = ({
  handleCreateVendorCertification,
  closeModalDialog,
}) => {
  return (
    <FormikForm
      initialValues={{ name: "", description: "" }}
      onSubmit={handleCreateVendorCertification}
      validationSchema={BWModels.loadSchema("Certification")}
    >
      {({ handleSubmit, values, ...formikProps }) => (
        <Wrapper>
          <FormGrid fields={fields} {...formikProps} />
          <ActionButtons
            onSend={handleSubmit}
            onCancel={closeModalDialog}
            sendButtonText="Create"
            listeners={[vendorCertificationDataComponentId]}
            isModal
          />
        </Wrapper>
      )}
    </FormikForm>
  );
};
